import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig, ActiveState } from '@datorama/akita';
import { Deposit } from '../../models/index.js';

export enum VISIBILITY_FILTER {
  SHOW_ALL = 'SHOW_ALL',
}

export interface DepositsState extends EntityState<Deposit>, ActiveState {
  ui: {
    filter: VISIBILITY_FILTER;
  };
}
const initialState = {
  ui: {
    filter: VISIBILITY_FILTER.SHOW_ALL,
  },
};

// export interface DepositUI {}

// export interface DepositsUIState extends EntityState<DepositUI>, ActiveState {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'deposits', resettable: true, idKey: 'depositId' })
export class DepositsStore extends EntityStore<DepositsState> {
  // ui: EntityUIStore<DepositsUIState>;
  constructor() {
    super();
    // this.createUIStore().setInitialEntityState();
  }
}
